module.exports = __webpack_public_path__ + "static/media/ex-liquidity-icon1.3fda410c.svg";